import { type MilestoneType } from "@/generated/graphql"
import { Badge } from "@/components/reusables/ui/badge"
import BFText from "@/components/standard/BFText"
import React from "react"

type MilestoneStatus = "completed" | "pending" | "needs_action" | "blocked"

const getMilestoneStatus = (status: string): MilestoneStatus => {
  switch (status.toLowerCase()) {
    case "completed":
      return "completed"
    case "pending":
      return "pending"
    case "needs_action":
    case "needs action":
      return "needs_action"
    case "blocked":
      return "blocked"
    default:
      return "pending"
  }
}

const BADGE_VARIANTS: Record<
  MilestoneStatus,
  "success" | "secondary" | "destructive" | "outline" | "warning" | "muted"
> = {
  completed: "success",
  pending: "muted",
  needs_action: "warning",
  blocked: "outline",
}

const BADGE_TEXT: Record<MilestoneStatus, string> = {
  completed: "Complete",
  blocked: "Blocked",
  needs_action: "Needs Action",
  pending: "Pending",
}

export const MilestoneStatusBadge = ({
  milestone,
}: {
  milestone: MilestoneType
}) => {
  if (milestone.status === "completed") {
    return null
  }

  const milestoneStatus = getMilestoneStatus(milestone.status || "")

  return (
    <Badge variant={BADGE_VARIANTS[milestoneStatus]}>
      <BFText>{BADGE_TEXT[milestoneStatus].toUpperCase()}</BFText>
    </Badge>
  )
}
